<template>

  <header class="header">
    <nav class="header__nav">
      <div class="left"
           v-if="currentVideo"
           @click="goHome()">
        <b-icon-house class="header--icon home-btn"></b-icon-house>
      </div>
      <div v-if="isWebsite && !userInfo">
        <a href="#"
           class="language-btn"
           v-b-modal.modal-guide>
        <b-icon-question-circle class="guide-svg"></b-icon-question-circle></a>
        <b-dropdown text="En/中"
                    right
                    class="language-btn">
          <b-dropdown-item @click="$i18n.locale='en'">English</b-dropdown-item>
          <b-dropdown-item @click="$i18n.locale='cn'">简体中文</b-dropdown-item>
        </b-dropdown>
      </div>
      <ul v-if="userInfo"
          class="header__navbar">
        <div class="header__text">
          Hi, {{ username }}
        </div>
        <button v-if="showGift"
                class="gift-button">
          <b-icon-gift-fill v-b-modal.dailyRewardModal
                            font-scale="1.2"
                            class="b-icon-gift-button"></b-icon-gift-fill>
        </button>
        <li class="header__item">
          <a href="#"
             class="header__link">
            <transition name="fade">
              <!-- Header Navigation Menu Icons -->
              <button class="header--button"
                      v-if="show"
                      key="on"
                      @click="show = false">
                <svg viewBox="0 0 24 24"
                     class="header--icon">
                  <title>Close</title>
                  <path d="M0 0h24v24H0V0z"
                        fill="none" />
                  <path fill="currentColor"
                        d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
                </svg>
              </button>
              <button class="header--button"
                      v-else
                      key="off"
                      @click="show = true">
                <svg viewBox="0 0 496 512"
                     class="header--icon">
                  <title>Navigation Menu</title>
                  <path fill="currentColor"
                        d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm128 421.6c-35.9 26.5-80.1 42.4-128 42.4s-92.1-15.9-128-42.4V416c0-35.3 28.7-64 64-64 11.1 0 27.5 11.4 64 11.4 36.6 0 52.8-11.4 64-11.4 35.3 0 64 28.7 64 64v13.6zm30.6-27.5c-6.8-46.4-46.3-82.1-94.6-82.1-20.5 0-30.4 11.4-64 11.4S204.6 320 184 320c-48.3 0-87.8 35.7-94.6 82.1C53.9 363.6 32 312.4 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 56.4-21.9 107.6-57.4 146.1zM248 120c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 144c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z" />
                </svg>
              </button>
            </transition>
          </a>
          <!-- Dropdown Menu -->
          <transition name="dropdown">
            <div class="dropdown__menu"
                 v-bind:class="{ active: show }"
                 v-if="show">
              <ul class="dropdown__menu-nav">
                <li class="dropdown__menu-item">
                  <div class="dropdown__menu-link"
                       title="My Petal Balance">
                    <img class="dropdown__menu-svg"
                         src="static/images/petal_icon.svg">
                    <div class="dropdown__menu-text"> {{ $t('text.balance') }} {{ showBalance }} </div>
                  </div>
                </li>
                <li class="dropdown__menu-item">
                  <a href="#"
                     v-b-modal.dailyRewardModal
                     class="dropdown__menu-link"
                     title="Daily Reward">
                    <b-icon-award class="dropdown__menu-svg"></b-icon-award>
                    <div class="dropdown__menu-text">{{ $t('home.dailyReward') }}</div>
                  </a>
                </li>
                <li class="dropdown__menu-item">
                  <a href="#"
                     v-b-modal.shareLinkModal
                     class="dropdown__menu-link"
                     title="My Sharing Link">
                    <b-icon-person-plus class="dropdown__menu-svg"></b-icon-person-plus>
                    <div class="dropdown__menu-text">{{ $t('home.invitePeople') }}</div>
                  </a>
                </li>
                <li class="dropdown__menu-item">
                  <a href="#"
                     v-b-modal.feedbackModal
                     class="dropdown__menu-link"
                     title="Send feedback">
                    <b-icon-envelope class="dropdown__menu-svg"></b-icon-envelope>
                    <div class="dropdown__menu-text">{{ $t('home.sendFeedback') }}</div>
                  </a>
                </li>
                <li class="dropdown__menu-item">
                  <a href="#"
                     v-b-modal.languageModal
                     class="dropdown__menu-link"
                     title="Language">
                    <b-icon-chat-dots class="dropdown__menu-svg"></b-icon-chat-dots>
                    <div class="dropdown__menu-text">{{ $t('text.language') }}</div>
                  </a>
                </li>
                <li class="dropdown__menu-item">
                  <a href="#"
                     v-b-modal.aboutModal
                     class="dropdown__menu-link"
                     title="Help">
                    <b-icon-question-circle class="dropdown__menu-svg"></b-icon-question-circle>
                    <div class="dropdown__menu-text">{{ $t('home.about') }}</div>
                  </a>
                </li>
                <!-- <hr> -->
                <li class="dropdown__menu-item">
                  <a href="#"
                     @click="logout()"
                     class="dropdown__menu-link"
                     title="Logout">
                    <b-icon-box-arrow-left class="dropdown__menu-svg"></b-icon-box-arrow-left>
                    <div class="dropdown__menu-text">{{ $t('home.logout') }}</div>
                  </a>
                </li>
              </ul>
            </div>
          </transition>
        </li>
      </ul>
    </nav>
    <b-modal id="modal-guide"
             ref="guideModal"
             :title="$t('guide.title')"
             hide-footer>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab :title="isWebsite? $t('guide.loginTitle') : $t('guide.loginMobileTitle')"
                 :active="!userInfo">
            <p>{{ $t('guide.loginText1') }}</p>
            <img class="guide-img"
                 src="static/images/guide-img1.jpg">
            <p>{{ $t('guide.loginText2') }}</p>
            <img class="guide-img"
                 src="static/images/guide-img2.jpg">
            <p>{{ $t('guide.loginText3') }}</p>
            <img class="guide-img"
                 src="static/images/guide-line.jpg">
            <p>{{ $t('guide.loginText4') }}</p>
            <img class="guide-img"
                 src="static/images/guide-facebook.jpg">
            <p>{{ $t('guide.loginText5') }}</p>
            <img class="guide-img"
                 src="static/images/guide-img3.jpg">
            <img class="guide-img"
                 src="static/images/guide-img4.jpg">
          </b-tab>
          <b-tab :title="isWebsite? $t('guide.shareTitle') : $t('guide.shareMobileTitle')"
                 :active="userInfo">
            <div v-if="isWebsite">
              <p>{{ $t('guide.shareSubTitle1') }}</p>
              <p>{{ $t('guide.shareText1') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share1.jpg">
              <p>{{ $t('guide.shareText2') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share2.jpg">
              <p>{{ $t('guide.shareText3') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share3.jpg">
              <img class="guide-img"
                   src="static/images/guide-share4.jpg">
            </div>
            <div v-else>
              <p>{{ $t('guide.shareSubTitle2') }}</p>
              <p>{{ $t('guide.shareText4') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share5.jpg">
              <p>{{ $t('guide.shareText5') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share6.jpg">
              <p>{{ $t('guide.shareText6') }}</p>
              <img class="guide-img"
                   src="static/images/guide-share7.jpeg">
              <img class="guide-img"
                   src="static/images/guide-share8.jpg">
            </div>
          </b-tab>
          <b-tab :title="isWebsite? $t('guide.ruleTitle') : $t('guide.ruleMobileTitle')">
            <p class="rule-text">{{ $t('guide.ruleText') }}</p>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
    <b-modal id="shareLinkModal"
             title="My Share Link"
             ref="shareLinkModal"
             centered
             ok-only
             hide-header
             hide-footer>
      <div class="about-container">
        <div class="about-title">
          {{ $t('home.invitePeople') }}
        </div>
        <div class="about-text">
          {{ $t('home.inviteDscription') }}
        </div>
        <div class="p-10"
             v-if="isMobileApp">
          <button @click="inviteFromApp('twitter')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/twitter-logo.jpeg">
          </button>
          <button @click="inviteFromApp('wechat')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/wechat-logo.png">
          </button>
          <button @click="inviteFromApp('instagram')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/instagram-logo.jpg">
          </button>
          <button @click="inviteFromApp('facebook')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/facebook-logo.png">
          </button>
          <button @click="inviteFromApp('weibo')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/weibo-logo.jpg">
          </button>
          <button @click="inviteFromApp('qq')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/qq-logo.jpg">
          </button>
        </div>
        <textarea
          v-else
          class="share-url-input p-10"
          v-model="shareURL"
          ref="urlToCopy"
          rows="2"
          readonly>
        </textarea>
      </div>
      <div class="close-share-btn">
        <b-button
          v-if="!isMobileApp"
          variant="outline-success"
          class="m-10"
          @click="copyShareLink">
          {{ $t('home.copy') }}
        </b-button>
        <b-button
          variant="outline-dark"
          class="m-10"
          @click="closeShareModal">
          {{ $t('home.close') }}
        </b-button>
      </div>
    </b-modal>
    <b-modal id="aboutModal"
             title="About"
             ref="aboutModal"
             centered
             ok-only
             hide-header
             hide-footer>
      <button
        class="close btn-close"
        @click="closeAboutModal">
        <b-icon-x></b-icon-x>
      </button>
      <div class="about-container">
        <div class="about-title">
          {{ $t('home.about') }} Petal
        </div>
        <div class="version m-3">
          {{ $t('home.version') }} {{ version }}
        </div>
        <div class="petal-description m-3">
          {{ $t('home.introduction') }}
        </div>
        <div class="petal-description m-3">
          {{ $t('home.giftSpec') }}
          <b-table striped
                   bordered
                   class="mt-1"
                   small
                   :fields="giftTableHeader"
                   :items="gifts"></b-table>
        </div>
        <div class="petal-description m-3 rule-text">
          {{ $t('guide.ruleText') }}
        </div>
        <div class="right-reserved m-3">
          {{ $t('home.devlopedBy') }}
        </div>
      </div>
    </b-modal>
    <b-modal id="languageModal"
             :title="$t('text.language')"
             ref="languageModal"
             centered
             ok-only>
      <div class="about-container">
        <b-button variant="info"
                  class="m-2"
                  @click="$i18n.locale='en'">
          English
        </b-button>
        <b-button variant="info"
                  class="m-2"
                  @click="$i18n.locale='cn'">
          简体中文
        </b-button>
      </div>
    </b-modal>
    <b-modal id="feedbackModal"
             :title="$t('home.sendFeedback')"
             ref="feedbackModal"
             centered
             ok-only>
      <div class="about-container">
        <b-button variant="info"
                  class="m-3 modal-icon-text"
                  href="mailto:petal.developer@gmail.com">
          <b-icon-envelope class="dropdown__menu-svg"></b-icon-envelope>
          Email
        </b-button>
        <b-button variant="info"
                  class="m-3 modal-icon-text"
                  href="https://www.facebook.com/dv.petal"
                  target="_blank">
          <img class="dropdown__menu-svg"
               src="static/images/facebook-logo.png">
          Facebook
        </b-button>
      </div>
    </b-modal>
    <b-modal id="dailyRewardModal"
             :title="$t('home.dailyReward')"
             ref="dailyRewardModal"
             centered
             ok-only
             hide-footer>
      <div class="about-container">
        <div v-if="dailyRewardTimeLeft>0"
             class="m-2">
          <b>{{ $t('account.nextRewardTimeLeft') }}:</b> {{ displayDailyRewardTime }}
        </div>
        <div v-else
             class="m-2">
          {{ $t('account.canPickupReward') }}
        </div>
        <b-button variant="warning"
                  class="m-2"
                  :disabled="dailyRewardTimeLeft>0"
                  @click="getUserDailyReward()">
          {{ $t('text.getReward') }}
        </b-button>
      </div>
    </b-modal>
  </header>

</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getBaseUrl, getDailyReward } from '@/utils/api'
import { VERSION, SMALL_GIFT, MIDDLE_GIFT, BIG_GIFT } from '@/constants'
import { displayBalance, secondsToHHMMSS } from '@/utils/common'

export default {
    data: function() {
        return {
            show: false,
            isMobileApp: process.env.PLATFORM === 'mobile_app',
            isWebsite: process.env.PLATFORM === 'website',
            dailyRewardTimeLeft: 0,
            showGift: false,
            version: VERSION
        }
    },
    created() {
        setInterval(this.updateDailyRewardTimeLeft, 1000)
    },
    methods: {
        ...mapActions(['setUserInfo', 'selectVideo', 'setUserNextRewardTime', 'setSharedVideoCount', 'setActivePoint', 'setUserBalance']),
        goHome() {
            this.selectVideo(null)
            this.$router.push({path: '/'})
        },
        logout() {
            localStorage.removeItem('user_token')
            localStorage.removeItem('user_token_ts')
            this.setUserInfo(false)
        },
        inviteFromApp(app) {
            if (!this.isMobileApp || typeof window.plugins === 'undefined') {
                return
            }
            let url = this.shareURL
            let message = this.username + ' ' + this.$t('home.inviteMsg') + '\n'
            let msgWithURL = message + url
            if (app === 'twitter') {
                window.plugins.socialsharing.shareViaTwitter(message, null /* img */, url, this.shareSuccess, this.shareFailed)
            } else if (app === 'facebook') {
                window.plugins.socialsharing.shareViaFacebookWithPasteMessageHint(msgWithURL, null /* img */, null, 'Paste it!', this.shareSuccess, this.shareFailed)
            } else if (app === 'weibo') {
                window.plugins.socialsharing.shareVia('com.sina.weibo', message, null, null, url, this.shareSuccess, this.shareFailed)
            } else if (app === 'wechat') {
                window.plugins.socialsharing.shareVia('com.tencent.mm', message, null, null, url, this.shareSuccess, this.shareFailed)
            } else if (app === 'instagram') {
                window.plugins.socialsharing.shareViaInstagram(msgWithURL, null, this.shareSuccess, this.shareFailed)
            } else if (app === 'qq') {
                window.plugins.socialsharing.shareVia('com.tencent.mobileqq', message, null, null, url, this.shareSuccess, this.shareFailed)
            }
        },
        shareSuccess() {
            console.log('share ok')
        },
        shareFailed(msg) {
            alert(this.$t('text.error') + ': ' + this.$t('share.shareError'))
        },
        closeAboutModal() {
            this.$refs.aboutModal.hide()
        },
        closeShareModal() {
            this.$refs.shareLinkModal.hide()
        },
        copyShareLink() {
            this.$refs.urlToCopy.select()
            window.document.execCommand('copy')
        },
        getUserDailyReward() {
            if (!this.userInfo) {
                return
            }
            getDailyReward(this.activePoint).then(res => {
                if (res.data.status === 'ok') {
                    this.setSharedVideoCount(0)
                    this.setActivePoint(0.0001)
                    this.setUserBalance(res.data.balance)
                    this.setUserNextRewardTime(res.data['next_timestamp'])
                    let referralReward = res.data['accumulated_referral_reward']
                    if (referralReward > 0) {
                        alert(this.$t('home.getDaliyAndReferralReward', { 'daily': res.data.reward, 'referral': referralReward }))
                    } else {
                        alert(this.$t('home.getReward') + res.data.reward)
                    }
                }
            }).catch(error => {
                console.log(error)
            })
        },
        updateDailyRewardTimeLeft() {
            if (this.userInfo && this.userInfo['next_reward'] > this.nextDailyRewardTime) {
                this.setUserNextRewardTime(this.userInfo['next_reward'])
            }
            let now = Math.round(new Date().getTime() / 1000)
            if (this.nextDailyRewardTime > now) {
                this.dailyRewardTimeLeft = this.nextDailyRewardTime - now
                this.showGift = false
            } else {
                this.dailyRewardTimeLeft = 0
                this.showGift = !!this.userInfo
            }
        }
    },
    computed: {
        ...mapGetters(['userInfo', 'userBalance', 'currentVideo', 'nextDailyRewardTime', 'activePoint']),
        username() {
            return this.userInfo ? this.userInfo.name : 'User'
        },
        shareURL() {
            if (this.userInfo) {
                return getBaseUrl() + '/#/?code=' + this.userInfo.ref_code
            } else {
                return '(Please login to get your share link)'
            }
        },
        showBalance() {
            return displayBalance(this.userBalance)
        },
        displayDailyRewardTime() {
            return secondsToHHMMSS(this.dailyRewardTimeLeft)
        },
        gifts() {
            return [
                { type: this.$t('video.smallGift'), cost: SMALL_GIFT + ' ' + this.$t('text.petal'), effects: this.$t('video.smallPresentTips') },
                { type: this.$t('video.middleGift'), cost: MIDDLE_GIFT + ' ' + this.$t('text.petal'), effects: this.$t('video.middlePresentTips') },
                { type: this.$t('video.bigGift'), cost: BIG_GIFT + ' ' + this.$t('text.petal'), effects: this.$t('video.bigPresentTips') }
            ]
        },
        giftTableHeader() {
            return [
                {key: 'type', label: this.$t('text.type'), thStyle: { minWidth: '50px' }},
                {key: 'cost', label: this.$t('text.cost'), thStyle: { minWidth: '100px' }},
                {key: 'effects', label: this.$t('text.effects'), thStyle: { minWidth: '100px' }}
            ]
        }
    }
}
</script>
<style scoped>

body {
  font-size: 1rem;
  -webkit-text-size-adjust: 100%;
  overflow: hidden;
}
hr {
  border: 0;
  height: 0;
  margin: 1.5rem 0;
  border-top: 1px solid gainsboro;
}

 /* Header Menu */

.header {
  padding: 0.5rem 2rem 0.1rem 0.1rem;
}

.header__text {
  padding: 0rem 1rem 0rem 0rem;
}

.header--icon {
  width: 1.65rem;
  height: 1.65rem;
}
.header--button {
  top: 0;
  right: 0;
  position: absolute;
  margin: 0;
  padding: 0;
  color: gray;
  cursor: pointer;
  border: 1px solid transparent;
  background-color: transparent;
}

.header--button :focus {
  outline: 0;
}

.header__nav {
  position: relative;
}
.header__navbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  list-style-type: none;
}
.header__item {
  padding: 1rem;
}

/* Dropdown Menu */

.dropdown__menu {
  top: 100%;
  right: 0;
  position: absolute;
  z-index: 999;
  min-width: 200px;
  margin-top: 1rem;
  overflow-y: auto;
  padding: 1rem 1rem 1rem 0rem;
  border-radius: 12px;
  background-color: white;
  border: 1px solid gainsboro;
  background-clip: padding-box;
}

.dropdown__menu-nav {
  padding: 0;
}

.dropdown__menu-item {
  list-style-type: none;
}

.dropdown__menu-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.6);
  padding: 0.8rem 0 0.8rem 2rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  border-radius: 0 50px 50px 0;
}
.dropdown__menu-link :hover {
  color: #17bf63;
  background-color: rgba(79, 192, 141, 0.1);
}
.dropdown__menu-svg {
  width: 1.5rem;
  height: 1.5rem;
}
.dropdown__menu-text {
  font-weight: 300;
  margin-left: 1rem;
  margin-right: 1rem;
}
>>>.btn-secondary {
  border: none;
  background: transparent;
  color: #4A90E2;
}

/* Animation Menu Icon */

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.6s;
}
.slide-fade-enter,
.slide-fade-leave-active {
  opacity: 0;
}
.slide-fade-enter {
  transform: translateX(31px);
}
.slide-fade-leave-active {
  transform: translateX(-31px);
}

/* Dropdown Menu Animation */

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.5s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

/* Wrapper */

.main {
  margin: 6rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.main__subtitle {
  color: #4f5959;
  font-weight: 100;
  margin-bottom: 2rem;
}
.main__link {
  margin-right: 1.5rem;
  display: inline-block;
}
.main__link :last-child {
  margin-right: 0;
}
.main__svg {
  width: 2rem;
  height: 2rem;
  opacity: 0.6;
  color: #94a2b0;
}
.main__svg :hover {
  color: #ffad1f;
}

.btn-close {
    position: absolute;
    right: 20px;
}
.about-container {
    text-align: center;
}
.about-title {
    color:#181B3A;
    font-size: 34px;
}
.version {
    color:#9091A3;
    font-size:18px;
}
.about-text {
    margin: 30px 15px 20px 15px;
    color:#4F515E;
    font-size:15px;
    text-align: left;
}
.right-reserved {
    text-align: center;
    color:#9091A3;
    font-size:15px;
}
.petal-description {
    text-align: left;
    color:rgb(0, 0, 0);
    font-size:15px;
}
.btn-copy {
    position: absolute;
    right:10;
    margin-top: 15px;
}
.close-share-btn {
    width: 100%;
    text-align: center;
}
.m-top-bottom-20 {
    margin-top: 20px;
    margin-bottom: 20px;
}
.m-10 {
    margin: 10px;
}
.p-10 {
    padding: 10px;
}
.left {
  float: left;
}
.share-url-input {
  width: 100%;
}
.home-btn {
  margin-left: 1.5rem;
  cursor: pointer;
}
.language-btn {
  float: right;
  margin-right: 10px;
}
.modal-icon-text {
  font-size: 1.2rem;
}
.invite-app-img {
  width: 46px;
  height: 46px;
}
.guide-img {
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
}
.invite-app-btn {
    background-color: #fff;
    border: white 1px solid;
    border-radius: 8px;
    margin: 2px;
}
.rule-text {
  white-space: pre-line;
}
.guide-svg {
  width: 20px;
  height: 40px;
}
.b-icon-animation-throb {
  animation-duration: 1.5s;
  color: #dc3535;
  outline:none;
}
.b-icon-gift-button {
  color: #dc3535;
  outline:none;
  -webkit-animation-name: giftAnimation;
  -webkit-animation-duration: 5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
}
@-webkit-keyframes giftAnimation {
  0% {
    transform:rotate(0deg)
  }
  5%,8% {
    transform:rotate(15deg)
  }
  8%,12% {
    transform:rotate(-15deg)
  }
  12%,16% {
    transform:rotate(15deg)
  }
  16%,20% {
    transform:rotate(-15deg)
  }
  20% {
    transform:rotate(0deg)
  }
}
.gift-button {
  outline:none;
  background: transparent;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue